<fui-text-control [(ngModel)]="value" [placeholder]="placeholder" [attr.id]="elementId"
                  [removable]="removable"
                  [label]="label"
                  (removed$)="onRemove()"></fui-text-control>
